import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  popover: null,
  pinnedPopover: null,
  incidentPopover: null,
  nonCallPopover: null,
  alertPopover: null,
  w3wPopover: null,
  airAmbulancePopover: null,
};

const mapPopoverSlice = createSlice({
  name: 'mapPopoverSlice',
  initialState,
  reducers: {
    showPopover(state, action) {
      const { payload } = action;
      state.popover = payload;
    },
    hidePopover(state) {
      state.popover = null;
    },
    showPinnedPopover(state, action) {
      const { payload } = action;
      state.pinnedPopover = payload.loc;
    },
    hidePinnedPopover(state) {
      state.pinnedPopover = null;
    },
    showIncidentPopover(state, action) {
      const { payload } = action;
      state.incidentPopover = payload;
    },
    hideIncidentPopover(state) {
      state.incidentPopover = null;
    },
    showNonCallPopover(state, action) {
      const { payload } = action;
      state.incidentPopover = payload;
    },
    hideNonCallPopover(state) {
      state.incidentPopover = null;
    },
    showAlertPopover(state, action) {
      const { payload } = action;
      state.alertPopover = payload;
    },
    hideAlertPopover(state) {
      state.alertPopover = null;
    },
    showW3WPopover(state, action) {
      const { payload } = action;
      state.w3wPopover = payload;
    },
    hideW3WPopover(state) {
      state.w3wPopover = null;
    },
    showAirAmbulancePopover(state, action) {
      const { payload } = action;
      state.airAmbulancePopover = payload;
    },
    hideAirAmbulancePopover(state) {
      state.airAmbulancePopover = null;
    },
  },
});

export const {
  showPopover,
  hidePopover,
  showPinnedPopover,
  hidePinnedPopover,
  showIncidentPopover,
  hideIncidentPopover,
  showAlertPopover,
  hideAlertPopover,
  showW3WPopover,
  hideW3WPopover,
  showNonCallPopover,
  hideNonCallPopover,
  showAirAmbulancePopover,
  hideAirAmbulancePopover,
} = mapPopoverSlice.actions;
export default mapPopoverSlice.reducer;
